<template>
	<div class="form-group input-time">
		<label :for="name" :class="{ error: errors.has(name) }">{{ placeholder }}</label>
		<input-time-selects :name="name" :id="name" v-model="model" v-validate="rules" :data-vv-as="placeholder"/>
		<span v-if="rules" v-show="errors.has(name)" class="text-danger">{{ errors.first(name) }}</span>
	</div>
</template>

<script>
import InputTimeSelects from './extra/InputTimeSelects'
export default {
	components: {
		InputTimeSelects
	},
	inject: ['$validator'],
	props: [
		'value',
		'name',
		'placeholder',
		'rules'
	],
	computed: {
		model: {
			get () {
				return this.value
			},
			set (value) {
				this.$emit('input', value)
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/InputTime.vue